/* eslint-disable */
// jshint ignore: start
import { baseUrl } from '@/config';
import store from '@/store';
import merge from 'lodash/merge';
import min from 'lodash/min';
import reduce from 'lodash/reduce';
import find from 'lodash/find';
import pull from 'lodash/pull';
import map from 'lodash/map';
import filter from 'lodash/filter';
import cloneDeep from 'lodash/cloneDeep';
import isEmpty2 from 'lodash/isEmpty';

import MapConst from '@/constants/topologymap';
import { convertValuByUnit } from '@/utils/number';
import { Q, MapInfo, MapUtil } from '@/views/topologymap/js/maps';
import { isEmpty } from '@/utils/basic';

/**
 * 기본 Model
 * 공통으로 사용되는 함수를 정의하였다.
 * @constructor
 */
(function(Q) {
  var DEFAULT_SIZE = 46;
  var LEGEND_ICON_SIZE = (18 / DEFAULT_SIZE);
  var LEGEND_ICON_OFFSET = (3 / DEFAULT_SIZE);
  var LEGEND_ICON_ZINDEX = 5;

  function BaseModel() {
      Q.doSuperConstructor(this, BaseModel);
  }
  BaseModel.prototype = {
    /**
     * 모델 초기화
     * @param  {[type]} model [description]
     * @return {[type]}       [description]
     */
    initialize: function(model) {
      var self = this;

      // 툴팁 초기화.
      self.tooltip = ' ';
      self.dblclickable = false;

      model = self.registerProperty(model);

      // 웹서비스에서 오브젝트가 Db에 추가 될 때 어떤 ElementId로 생성되는지 확인하기 위해 사용된다.
      model.refId = this.id;

      if(model.elementId) {
        this.id = model.elementId;
      }

      self.set('model', model);

      self.update();
    },
    /**
     * Model의 프로퍼티(속성) 변경을 감지 할 수 있도록한다.
     * @param  {[type]} model [description]
     * @return {[type]}       [description]
     */
    registerProperty: function(model) {
      var self = this;

      if(self.defaultProperty) {
        model = merge(self.defaultProperty(), model);
      }

      for(var property in model) {
        var value = model[property];

        if(value && !Array.isArray(value) && typeof value === 'object' && Object.keys(value).length > 0) {
          for(var subProperty in value) {
              self.set(property + '.' + subProperty, value[subProperty]);
          }
        } else {
          self.set(property, value);
        }
      }

      return model;
    },
    /**
     * Model의 프로퍼티(속성)이 변경 될 때 호출된다.
     * @param  {[type]} evt [description]
     * @return {[type]}     [description]
     */
    onChangeProperty: function(evt) {
      var self = this,
          value = evt.value,
          propertyName = evt.propertyName,
          model = self.get('model');

      // 웹서버에서 속성이 변경 된 모델만 업데이트하기 위한 플래그
      model['isChanged'] = true;

      // Q.log('### change : ' + evt.source.class.name + ' - ' + evt.kind + ' ###');

      if(self.properties.hasOwnProperty(propertyName)) {
        var propertyNames = propertyName.split('.');
        if(propertyNames.length > 1) {
            model[propertyNames[0]][propertyNames[1]] = value;
        } else {
            model[propertyName] = value;
        }
        self.update && self.update(); // 커스텀 프로퍼티 인 경우에만 업데이트한다.
      } else {
        if(evt.kind === 'location') {
          this.properties.x = model.x = value.x;
          this.properties.y = model.y = value.y;
        } if(evt.kind === 'rotate') {
          this.properties.r = model.r = value * 180 / Math.PI;
        } else if(evt.kind === 'size') {
          this.properties.width = model.width = value.width;
          this.properties.height = model.height = value.height;
        } else if(evt.kind === 'path.segment') {  //가상랜
          if(evt.source instanceof ShapeModel) {
            this.properties.width = model.width = evt.source.path.bounds.width;
            this.properties.height = model.height = evt.source.path.bounds.height;
          } else {
            if(evt.source instanceof VirtualLanModel) {
              this.properties.length = model.length = evt.source.path.length;
              this.properties.x = model.x = evt.source.x;
              this.properties.y = model.y = evt.source.y;
            }

            var pathSegments = [];
            evt.source.pathSegments.forEach(function(item) {
              pathSegments.push(item.toJSON());
            })
            this.properties['lineOptions.pathSegments'] = model.lineOptions.pathSegments = pathSegments;
          }
        } else if(evt.kind == 'edge.from.offset') {
          this.properties['lineOptions.fromOffset'] = model.lineOptions.fromOffset = value;
        } else if(evt.kind == 'edge.to.offset') {
          this.properties['lineOptions.toOffset'] = model.lineOptions.toOffset = value;
        }else if (evt.source instanceof LabelModel && evt.kind == 'name'){
          //20108.03.29 : LabelModel 더블클릭 후 텍스트 변경했을 때 처리
          this.properties.text = model.text = value;
        }
      }
    },
  };
  Q.extend(Q.Node, BaseModel);
  Q.extend(Q.Edge, BaseModel);
  Q.extend(Q.Text, Q.Node);
  Q.extend(Q.ShapeNode, Q.Node);
  Q.extend(Q.Bus, Q.ShapeNode);

  /**
   * 관리대상 Model
   * @param       {[type]} model [description]
   * @constructor
   */
  function ManagedObjectModel(model) {
      Q.doSuperConstructor(this, ManagedObjectModel);

      this.initialize(model);
      this.tooltip = '';
  }
  ManagedObjectModel.prototype = {
      update: function() {
        var model = this.get('model');
        this.name = getName(model);
        this.image = getImage(this);
        this.size = getSize(this.size, model);
        this.x = parseInt(model.x);
        this.y = parseInt(model.y);
        this.rotate = parseInt(model.r) * Math.PI / 180;
        this.zIndex = parseInt(model.z);

        this.setVisible(model);

        this.updateUnmanaged(model.isObj === false);

        applyStyle(this, model);

        Q.WidgetUI(this);
      },
      setVisible: function(model) {
        var visible = true;

        if (model.objtypeId === 'L2SW' || model.objtypeId === 'L3SW') {
          if (Object.prototype.hasOwnProperty.call(localStorage, 'map.filter.layer')) {
            visible = localStorage.getItem('map.filter.layer').split(',').indexOf(model.objtypeId) > -1;
          }

          window.filterLayerEnable = true;
        }

        this.visible = visible;
      },
      disconnectList: [],
      updateExpandState: function() {
        var model = this.get('model');

        // 인터페이스(포트)는 해당사항 없음
        if (model.objtypeId == 'NETINTERFACE') {
          return;
        }

        if (window.ipaddressToConnectInfo && window.ipaddressToConnectInfo[model.ipaddress]) {
          this.disconnectList = cloneDeep(window.ipaddressToConnectInfo[model.ipaddress]);

          this.forEachEdge(function(edge) {
            var fromModel = edge.fromAgent.get('model');
            var toModel = edge.toAgent.get('model');
            var edgeModel = edge.get('model');
            var key1 = fromModel.ipaddress + '/' + edgeModel.srcIfIndex + '/' + toModel.ipaddress + '/' + edgeModel.dstIfIndex;
            var key2 = toModel.ipaddress + '/' + edgeModel.dstIfIndex + '/' + fromModel.ipaddress + '/' + edgeModel.srcIfIndex;

            delete this.disconnectList[key1];
            delete this.disconnectList[key2];
          }.bind(this));

          if (!isEmpty2(this.disconnectList)) {
            if (!this.connectExpandUI) {
              var ui = new Q.ImageUI();
              ui.position = Q.Position.RIGHT_TOP;
              ui.anchorPosition = Q.Position.RIGHT_TOP;
              var minSize = min([this.size.width, this.size.height]);
              ui.offsetX = (minSize * LEGEND_ICON_OFFSET);
              ui.offsetY = -(minSize * LEGEND_ICON_OFFSET);
              ui.size = {
                width: minSize * LEGEND_ICON_SIZE,
                height: minSize * LEGEND_ICON_SIZE,
              }
              ui.name = 'connectExpand';
              ui.zIndex = 1;
              this.connectExpandUI = ui;
              this.addUI(ui);
            }
            this.connectExpandUI.data = 'connect.svg';
          } else {
            if(this.connectExpandUI) {
              this.removeUI(this.connectExpandUI);
              this.connectExpandUI = null;
            }
          }
        }
        this.invalidate();
      },
      updateEvent: function(eventStatus) {
        this.eventStatus = eventStatus;

        this.updateEventLabel();
        this.updateAnimation();
        this.updateImportance((this.legend || {}).objImportance);
        this.update();
      },
      updateEventLabel: function() {
        var model = this.get('model');

        if(checkShowEvent(this, model) && (localStorage.getItem('map.filter.event') == 'SHOW' || (model.showEventLabelFlag == '1' && localStorage.getItem('map.filter.event') == 'DEFAULT'))) {
          if(!this.eventLabelUI) {
            var ui = new Q.LabelUI();
            ui.position = Q.Position.CENTER_TOP;
            ui.anchorPosition = Q.Position.CENTER_BOTTOM;
            ui.borderRadius = 5;
            ui.padding = new Q.Insets(2, 5);
            ui.showPointer = true;
            ui.offsetY = -7;
            ui.fontSize = model.labelOptions.labelSize;
            ui.fontFamily = model.labelFont;

            this.addUI(ui);
            this.eventLabelUI = ui;
          }
          this.eventLabelUI.backgroundColor = store.state.common.eventlevelInfo[this.eventStatus.eventlevelId].eventlevelColorBg;
          this.eventLabelUI.color = store.state.common.eventlevelInfo[this.eventStatus.eventlevelId].eventlevelColorText;
          this.eventLabelUI.data = this.eventStatus.eventMessage;
        } else {
          if(this.eventLabelUI) {
            this.removeUI(this.eventLabelUI);
            this.eventLabelUI = null;
          }
        }

        this.updateEventLabelPosition();
      },
      updateEventLabelPosition: function() {
        if(this.eventLabelUI) {
          if(this.companyNameUI) {
            this.eventLabelUI.pointerY = -20;
            this.eventLabelUI.offsetY = -27;
          } else {
            this.eventLabelUI.pointerY = 0;
            this.eventLabelUI.offsetY = -7;
          }
        }
      },
      updateResource: function(rscValue) {
        this.rscValue = rscValue

        this.makeResourceLabel(rscValue, 'value1');
        this.makeResourceLabel(rscValue, 'value2');
        const objtypeId = this.get('model').objtypeId;
        if (objtypeId === 'WIRELESSAP') {
          // 무선 AP에서는 툴팁에서 성능정보 3가지 표현
          this.makeResourceLabel(rscValue, 'value3');
        }

        this.makeRscUI('rsc1NameUI', Q.Position.RIGHT_MIDDLE, Q.Position.LEFT_BOTTOM, false, this['value1.rsc']);
        this.makeRscUI('rsc1ValueUI', Q.Position.RIGHT_MIDDLE, Q.Position.LEFT_BOTTOM, true, this['value1.value']);
        this.makeRscUI('rsc2NameUI', Q.Position.RIGHT_MIDDLE, Q.Position.LEFT_TOP, false, this['value2.rsc']);
        this.makeRscUI('rsc2ValueUI', Q.Position.RIGHT_MIDDLE, Q.Position.LEFT_TOP, true, this['value2.value']);

        this.update();
      },
      /**
       * 관리대상 성능UI
       */
      makeRscUI: function(name, position, anchorPosition, offset, label) {
        var model = this.get('model');

        if (localStorage.getItem('map.filter.rsc') == 'SHOW' || (parseInt(model.showRscFlag) == 1 && localStorage.getItem('map.filter.rsc') == 'DEFAULT')) {
          if(!this[name]) {
            var model = this.get('model');

            var ui = new Q.LabelUI();
            ui.position = position;
            ui.anchorPosition = anchorPosition;
            ui.offsetX = offset === true ? (model.labelOptions.labelSize * 2.5) + 3 : 5;
            ui.fontSize = model.labelOptions.labelSize * 0.8;
            ui.fontFamily = model.labelFont;
            ui.color = model.labelColor;
            ui.fontStyle = 'bold';

            this.addUI(ui);
            this[name] = ui;
          }

          this[name].data = label;
        } else {
          if (this[name]) {
            this.removeUI(this[name]);
            this[name] = null;
          }
        }
      },
      makeResourceLabel: function(rscValue, type) {
        var model = this.get('model');

        var value = rscValue ? rscValue[type] : '-',
          name = '',
          rsc = '',
          unit = '';
        switch (model.objDefineId) {
          case 'SERVER':
            name = type == 'value1' ? 'CPU 사용률' : '메모리 사용률';
            rsc = type == 'value1' ? 'CPU' : 'MEM';
            unit = type == 'value1' ? '%' : '%';
            break;
          case 'NETDEVICE':
            name = type == 'value1' ? 'CPU 사용률' : '메모리 사용률';
            rsc = type == 'value1' ? 'CPU' : 'MEM';
            unit = type == 'value1' ? '%' : '%';
            break;
          case 'NETINTERFACE':
            name = type == 'value1' ? 'bps 입력' : 'bps 출력';
            rsc = type == 'value1' ? 'Rx' : 'Tx';
            unit = type == 'value1' ? 'bps' : 'bps';
            break;
          case 'WIRELESS_DEVICE':
            switch (model.objtypeId) {
              case 'AP_CONTROLLER':
                name = type == 'value1' ? '트래픽 IN' : '트래픽 OUT';
                rsc = type == 'value1' ? 'Rx' : 'Tx';
                unit = type == 'value1' ? 'bps' : 'bps';
                break;
              case 'WIRELESSAP':
                if (type == 'value1') {
                  name = '트래픽 IN';
                  rsc = 'Rx';
                  unit = 'bps';

                } else if (type == 'value2') {
                  name = '트래픽 OUT';
                  rsc = 'Tx';
                  unit = 'bps';
                } else if (type == 'value3') {
                  name = '접속자 수';
                  rsc = '';
                  unit = '';
                }
                break;
              default:
            }
            break;
          case 'DBMS':
            name = type == 'value1' ? '버퍼캐시 적중률' : 'DB공간 사용률';
            rsc = type == 'value1' ? 'HIT' : 'TBS';
            unit = type == 'value1' ? '%' : '%';
            break;
          case 'INSTANCE':
            if(model.objtypeId == 'WAS') {
              name = type == 'value1' ? 'CPU 사용률' : 'Heap 사용률';
              rsc = type == 'value1' ? 'CPU' : 'HEAP';
              unit = type == 'value1' ? '%' : '%';
            }
            break;
          case 'FMS_SENSOR':
            switch (model.objtypeId) {
              case 'FUPS': //UPS
                name = type == 'value1' ? 'Loading' : '바이패스';
                rsc = type == 'value1' ? 'LOAD' : 'Bypass';
                unit = type == 'value1' ? '%' : '%';
                break;
              case 'FTHEHYGRO': //항온항습 측정 센서
                name = type == 'value1' ? '온도' : '습도';
                rsc = type == 'value1' ? 'TEM' : 'HUM';
                unit = type == 'value1' ? '℃' : '%';
                break;
              case 'FTH': //온습도 측정 센서
                name = type == 'value1' ? '온도' : '습도';
                rsc = type == 'value1' ? 'TEM' : 'HUM';
                unit = type == 'value1' ? '℃' : '%';
                break;
              case 'FWLDS': //누수 측정 센서
                name = '누수경보';
                rsc = 'WLD';
                unit = '';
                if(type == 'value2') {
                  return;
                }
                break;
              case 'FFIREDS': //소방 감지 센서
                name = '연기감지';
                rsc = 'FIRE';
                unit = '';
                if(type == 'value2') {
                  return;
                }
                break;
              case 'FVSBMS': //분전 측정 센서
                name = type == 'value1' ? '상전압(R)' : '상전압(S)';
                rsc = type == 'value1' ? 'VTG(R)' : 'VTG(S)';
                unit = type == 'value1' ? 'V' : 'V';
                break;
              case 'FNSDS': //소음 측정 센서
                name = '소음크기';
                rsc = 'NSE';
                unit = 'dB';
                if(type == 'value2') {
                  return;
                }
                break;
              case 'FSENSOR': //동작 센서
                name = '문 열림 상태';
                rsc = 'DOOR';
                unit = '';
                if(type == 'value2') {
                  return;
                }
                break;
              case 'FAIRFLOW': //에어플로우
                name = '공기 흐름 상태';
                rsc = 'AIR';
                unit = 'm/min';
                if(type == 'value2') {
                  return;
                }
                break;
              case 'FCAM': //카메라
                name = ''
                rsc = '';
                unit = '';
                return;
                break;
              case 'FPDUS': //랙 전원 측정 센서
                name = type == 'value1' ? '입력전압' : '부하전류';
                rsc = type == 'value1' ? 'VTG' : 'CUR';
                unit = type == 'value1' ? 'V' : 'A';
                break;
              case 'FADC': //디지털 분배기
                name = '';
                rsc = '';
                unit = '';
                return;
                break;
              case 'FVA': //전압/전류 감시
                name = type == 'value1' ? '전압' : '전류';
                rsc = type == 'value1' ? 'VTG' : 'CUR';
                unit = type == 'value1' ? '' : '';
                break;
              case 'FCM': //단상전압감시
                name = '';
                rsc = '';
                unit = '';
                return;
                break;
              case 'FGCU': //발전기
                name = '배터리전압';
                rsc = 'BAT';
                unit = 'V';
                if(type == 'value2') {
                  return;
                }
                break;
              case 'FTEMP': //선형온도 센서
                name = '온도';
                rsc = 'TEM';
                unit = '℃';
                if(type == 'value2') {
                  return;
                }
                break;
              case 'FRT': //정류기
                name = type == 'value1' ? '축전지 전압' : '축전지 전류';
                rsc = type == 'value1' ? 'VTG' : 'CUR';
                unit = type == 'value1' ? 'V' : 'A';
                break;
            }
          case 'VMS_OBJECT':
            switch (model.objtypeId) {
              case 'VCL': //호스트 클러스터
                name = type == 'value1' ? 'CPU 사용률' : '메모리 사용률';
                rsc = type == 'value1' ? 'CPU' : 'MEM';
                unit = type == 'value1' ? '%' : '%';
                break;
              case 'VHO': //호스트
                name = type == 'value1' ? 'CPU 사용률' : '메모리 사용률';
                rsc = type == 'value1' ? 'CPU' : 'MEM';
                unit = type == 'value1' ? '%' : '%';
                break;
              case 'VVM': //VM
                name = type == 'value1' ? 'CPU 사용률' : '메모리 사용률';
                rsc = type == 'value1' ? 'CPU' : 'MEM';
                unit = type == 'value1' ? '%' : '%';
                break;
              case 'VDSC': //스토리지 클러스터
                name = '스토리지 사용률';
                rsc = 'STRG';
                unit = '%';
                if(type == 'value2') {
                  return;
                }
                break;
              case 'VDS': //호스트 클러스터
                name = '스토리지 사용률';
                rsc = 'STRG';
                unit = '%';
                if(type == 'value2') {
                  return;
                }
                break;
              default:
            }
          default:
        }

        if(value != '-') {
          value = convertValuByUnit(value, unit, false, true, false);
        } else {
          value = value + unit;
        }

        this[type+'.'+'name'] = name;
        this[type+'.'+'rsc'] = rsc;
        this[type+'.'+'value'] = value;
        this[type+'.'+'unit'] = unit;


        return rsc + ' ' + value;
      },
      updateLegend: function(legend) {
        if(!legend) {
          legend = {};
        }
        this.legend = legend;

        this.updateImportance(legend.objImportance);
        this.updateActive(legend.activeGetStr, legend.activeStatusStr);
        this.updateManagedApply(legend.objManagementApplyFlag);
        this.updateAutomapDeviceStatus(legend.status);
        this.updateUnmanaged(legend.isUnmanaged);
      },
      updateAutomapDeviceStatus(status) {
        if (status) {
          if (!this.automapDeviceStatusUI) {
            var ui = new Q.ImageUI();
            ui.position = Q.Position.RIGHT_TOP;
            ui.anchorPosition = Q.Position.RIGHT_TOP;
            ui.zIndex = LEGEND_ICON_ZINDEX;

            var minSize = min([this.size.width, this.size.height]);
            ui.offsetX = (minSize * LEGEND_ICON_OFFSET);
            ui.offsetY = -(minSize * LEGEND_ICON_OFFSET);
            ui.size = {
              width: minSize * LEGEND_ICON_SIZE,
              height: minSize * LEGEND_ICON_SIZE,
            }
            this.automapDeviceStatusUI = ui;
            this.addUI(ui);
          }

          this.automapDeviceStatusUI.data = status === 'N' ? 'add.svg' : 'delete.svg';
        } else {
          if(this.automapDeviceStatusUI) {
            this.removeUI(this.automapDeviceStatusUI);
            this.automapDeviceStatusUI = null;
          }
        }
        this.invalidate();
      },
      updateManagedApply: function(objManagementApplyFlag) {
        var model = this.get('model');

        model.objManagementApplyFlag = objManagementApplyFlag || '0';

        this.update();
      },
      updateUnmanaged: function(isUnmanaged) {
        if (isUnmanaged) {
          if(!this.unmanagedUI) {
            var ui = new Q.ImageUI();
            ui.position = Q.Position.LEFT_TOP;
            ui.anchorPosition = Q.Position.LEFT_TOP;
            ui.data = 'unknown.svg';
            ui.zIndex = LEGEND_ICON_ZINDEX;

            var minSize = min([this.size.width, this.size.height]);
            ui.offsetX = -(minSize * LEGEND_ICON_OFFSET);
            ui.offsetY = -(minSize * LEGEND_ICON_OFFSET);
            ui.size = {
              width: minSize * LEGEND_ICON_SIZE,
              height: minSize * LEGEND_ICON_SIZE,
            }

            this.unmanagedUI = ui;
            this.addUI(ui);
          }
        } else {
          if(this.unmanagedUI) {
            this.removeUI(this.unmanagedUI);
            this.unmanagedUI = null;
          }
        }
        this.invalidate();
      },
      updateActive: function(get, status) {
        if(get && get != 'H' && status) {
          if(!this.activeUI) {
            var ui = new Q.ImageUI();
            ui.position = Q.Position.LEFT_TOP;
            ui.anchorPosition = Q.Position.LEFT_TOP;

            var minSize = min([this.size.width, this.size.height]);
            ui.offsetX = -(minSize * LEGEND_ICON_OFFSET);
            ui.offsetY = -(minSize * LEGEND_ICON_OFFSET);
            ui.size = {
              width: minSize * LEGEND_ICON_SIZE,
              height: minSize * LEGEND_ICON_SIZE,
            }

            this.activeUI = ui;
            this.addUI(ui);
          }


          if(status == '1') {
            this.activeUI.data = 'active.svg';
          } else {
            this.activeUI.data = 'standby.svg';
          }
        } else {
          if(this.activeUI) {
            this.removeUI(this.activeUI);
            this.activeUI = null;
          }
        }
        this.invalidate();
      },
      updateImportance: function(importance) {
        var model = this.get('model');

        if(localStorage.getItem('map.filter.importance') == 'SHOW' || (model.styleOptions.showImportance && localStorage.getItem('map.filter.importance') == 'DEFAULT')) {
          var imageName = 'importance_' + importance + '.svg';

          if(Q.hasImage(imageName)) {
            var minSize = min([this.size.width, this.size.height]);
            var offsetX = -(minSize * LEGEND_ICON_OFFSET);
            var offsetY = (minSize * LEGEND_ICON_OFFSET);
            var size = {
              width: minSize * LEGEND_ICON_SIZE,
              height: minSize * LEGEND_ICON_SIZE,
            };
            if(!this.importanceUI) {
              var ui = new Q.ImageUI();
              ui.position = Q.Position.CENTER_BOTTOM;
              ui.anchorPosition = Q.Position.CENTER_BOTTOM;
              ui.offsetY = 3;
              ui.size = size;
              ui.zIndex = LEGEND_ICON_ZINDEX;
              this.importanceUI = ui;
              this.addUI(ui);
            }

            this.importanceUI.data = imageName;
          } else {
            if(this.importanceUI) {
              this.removeUI(this.importanceUI);
              this.importanceUI = null;
            }
          }
        } else {
          if(this.importanceUI) {
            this.removeUI(this.importanceUI);
            this.importanceUI = null;
          }
        }
        this.invalidate();
      },
      updateAnimation: function() {
        var model = this.get('model');

        if (MapInfo.getInstance(this).getGraph()) {
          MapInfo.getInstance(this).getGraph().eventEffectSupport.hide(this);
          if(MapInfo.getInstance(this).getGraph().editable == false && checkShowEvent(this, model) && localStorage.getItem('map.filter.animation') != 'HIDE') {
            MapInfo.getInstance(this).getGraph().eventEffectSupport.show(this);
          }
        }
      },
      defaultProperty: function() {
        return {
          elementId: null,
          customimageId: -1,
          label: '%node%',
          labelPosition: 'CB',
          labelOptions: {
            labelSize: 11,
            labelBold: false,
          },
          labelColor: '#000000',
          showLabelFlag: '1',
          labelBoxColor: '#ffffff',
          showLabelBoxFlag: '0',
          labelFont: '나눔고딕',
          x: null,
          y: null,
          z: 0,
          r: 0,
          width: 46,
          height: 46,
          alpha: 1,
          eventLabelPosition: 'RM',
          showEventLabelFlag: '0',
          showRscFlag: '0',
          showIfEvent: '1',
          styleOptions: {
            showImportance: true,
            showNormalColor: true,
            imageType: 'flat',
          },
        };
      }
  };
  Q.extend(ManagedObjectModel, Q.Node);


  /**
   * 회선 Model
   * @param       {[type]} model       [description]
   * @param       {[type]} srcElement [description]
   * @param       {[type]} dstElement [description]
   * @constructor
   */
  function LanModel(model, srcElement, dstElement) {
      Q.doSuperConstructor(this, LanModel, [srcElement, dstElement]);

      this.zIndex = -1;
      this.setStyle(Q.Styles.SELECTION_COLOR, '#008aff');
      this.setStyle(Q.Styles.SELECTION_SHADOW_OFFSET_X, 0);
      this.setStyle(Q.Styles.SELECTION_SHADOW_OFFSET_Y, 0);
      this.setStyle(Q.Styles.SELECTION_SHADOW_BLUR, 5);

      model.srcElementId = srcElement.get('elementId');
      model.dstElementId = dstElement.get('elementId');
      model.srcRefId = srcElement.get('model').refId;
      model.dstRefId = dstElement.get('model').refId;

      if((MapInfo.getInstance(this) && MapInfo.getInstance(this).getGraph().editable == false)) {
        if(model.srcNetinterfaceSpeed != void 0) {
          this.makeIfSpeed(model, 'SRC');
        }
        if(model.dstNetinterfaceSpeed != void 0) {
          this.makeIfSpeed(model, 'DST');
        }
        if(model.showTrafficLabel == '1') {
          this.makeRscValue(model);
        }
      }

      //2018.03.23 : edgeBundle 기능 컨트롤
      // edge의 validateEdgeBundle 에서 expanded를 강제로 펼쳐지도록 설정하기 위함
      // this.validateEdgeBundle = function(){
      //   var edgeBundle = this.getEdgeBundle();
      //   edgeBundle.expanded = true;
      // };

      if(model.lineOptions && model.lineOptions.pathSegments) {
        model.lineOptions.pathSegments.forEach(function(path) {
          if (path.type == Q.Consts.SEGMENT_CURVE_TO) {
            if (path.points.length > 4) {
              this.addPathSegment(path.points, path.type);
              this.pathSegments.get(0).invalidTerminal = true;
            }
          } else {
            this.addPathSegment(path.points, path.type);
          }
        }.bind(this));
      }

      if(model.lineOptions && model.lineOptions.fromOffset) {
        this.setStyle(Q.Styles.EDGE_FROM_OFFSET, model.lineOptions.fromOffset);
      }

      if(model.lineOptions && model.lineOptions.toOffset) {
        this.setStyle(Q.Styles.EDGE_TO_OFFSET, model.lineOptions.toOffset);
      }

      this.updateAutomapLanStatus(model);

      this.initialize(model);
      this.tooltip = '';
  }
  LanModel.prototype = {
      update: function() {
          var model = this.get('model');

          if(model.elementId) {
            this.id = model.elementId;
          }

          this.angle = parseInt(model.r) * Math.PI / 180;

          this.visible = localStorage.getItem('map.filter.line') != 'HIDE';

          this.updateIfLabel();

          applyStyle(this, model);
      },
      updateIfLabel: function() {
        var model = this.get('model');

        this.makeIfLabel(model, 'SRC');
        this.makeIfLabel(model, 'DST');
      },
      changeLineDirection: function() {
        if(this.hasPathSegments && this.hasPathSegments() == true) {
          this.removePathSegment(this.pathSegments.toDatas());
        }
      },
      changeAgent: function(direction, agent) {
        var model = this.get('model');

        if(direction == 'SRC') {
          this.from = agent;
          model.srcElementId = agent.get('elementId');
          model.srcRefId = agent.get('model').refId;
          model.srcObjId = -1;
        } else if(direction == 'DST') {
          this.to = agent;
          model.dstElementId = agent.get('elementId');
          model.dstRefId = agent.get('model').refId;
          model.dstObjId = -1;
        }
      },
      /**
       * 회선 성능 업데이트
       * @param  {[type]} rscValue [description]
       * @return {[type]}          [description]
       */
      updateResource: function(rscValue) {
        this.rscValue = rscValue

        var model = this.get('model');

        if(model.showTrafficLabel == '1') {
          var resultValue = '-';
          if (!isEmpty(rscValue)) {
            var srcInValue = !isEmpty(rscValue.value1) ? rscValue.value1 : null;
            var srcOutValue = !isEmpty(rscValue.value2) ? rscValue.value2 : null;
            var dstInValue = !isEmpty(rscValue.value3) ? rscValue.value3 : null;
            var dstOutValue = !isEmpty(rscValue.value4) ? rscValue.value4 : null;

            var valueArray = [srcInValue, srcOutValue, dstInValue, dstOutValue];
            var maxValue = Math.max.apply(null, valueArray);
            if (isEmpty(maxValue) || maxValue === 0) {
              resultValue = '0';
            } else {
              resultValue = MapUtil.changeUnitWithoutB(maxValue, 0, 'bps', true);
            }
          }
          this.set('rscValue', resultValue);
        }
      },
      /**
       * 이벤트 표현
       * @param  {[type]} eventStatus [description]
       * @return {[type]}             [description]
       */
      updateEvent: function(eventStatus) {
        this.eventStatus = eventStatus;

        this.update();
      },
      updateLanCurve: function() {
        if(!this.pathSegments || this.pathSegments.datas.length == 0){
          var from = this.from,
              to = this.to;
          var cx = (from.x + to.x) / 2;
          var cy = (from.y + to.y) / 2;
          var dx = from.x - to.x, dy = from.y - to.y;
          var distance = Math.sqrt(dx * dx + dy * dy);
          var angle = Math.atan2(dy, dx);
          distance = Math.min(30, distance * 0.2);
          if(angle > 0){
            distance = -distance;
          }
          var cos = Math.cos(angle) * distance;
          var sin = Math.sin(angle) * distance;
          this.addPathSegment([cx - cos, cy + sin, cx + cos, cy - sin], Q.Consts.SEGMENT_CURVE_TO);
        }
      },
      defaultProperty: function() {
        return {
          elementId: null,
          srcElementId: -1,
          dstElementId: -1,
          srcObjId: -1,
          dstObjId: -1,
          srcObjName: null,
          dstObjName: null,
          srcIfIndex: -1,
          dstIfIndex: -1,
          lineDirection: 'EDGE_TYPE_DEFAULT',
          showIfSpeedFlag: '0',
          showSrcIfLabel: '0',
          showDstIfLabel: '0',
          showTrafficLabel: '0',
          strokeType: '',
          strokeOptions: {
            weight: 1,
            color: '#000000',
            alpha: 1,
          },
          r: 90,
          showEventLabelFlag: '0',
          styleOptions: {
            showNormalColor: true,
          },
          lineOptions: {
            dashType: 'default',
            arrowType: 'N',  //N=none, S=src, D=dst, B=both
            pathSegments: [
              // 값 형태
              /* {
              //   "type:": "l",
  		        //   "points": [200, -180]
              } */
            ],
            fromOffset: {},
            toOffset: {},
            showIfLabelCombobox: 'alias',
            showIfLabelCheckbox: '1',
          }
        };
      },
      /**
       * 회선 대여폭을 표현한다.
       * @param  {[type]} model [description]
       * @param  {[type]} direction    [description]
       * @return {[type]}       [description]
       */
      makeIfSpeed: function(model, direction) {
        var cnt = 0,
            speed = direction == 'SRC' ? model.srcNetinterfaceSpeed : model.dstNetinterfaceSpeed,
            gap = 3,
            offset = 0;

        if(model.lineOptions && model.lineOptions.hasOwnProperty('arrowType')) {
          if(direction == 'SRC' && model.lineOptions.arrowType == 'S' || model.lineOptions.arrowType == 'B') {
            offset = 10;
          }

          if(direction == 'DST' && model.lineOptions.arrowType == 'D' || model.lineOptions.arrowType == 'B') {
            offset = 10;
          }
        }

        if(parseInt(speed) >= 1000000000) {  // 1G보다 크거나 같으면
          cnt = 3;
        } else if(parseInt(speed) >= 100000000) { // 100M보다 크거나 같으면
          cnt = 2;
        } else {
          cnt = 1;
        }

        for(var i=1; i<=cnt; i++) {
          var ui = new Q.ImageUI(Q.Shapes.getShape(Q.Consts.SHAPE_RECT, 0, 0, 1, 10));
          ui.fillColor = model.strokeOptions && model.strokeOptions.color;

          if(direction == 'SRC') {
            ui.position = Q.Position.LEFT_MIDDLE;
            ui.offsetX = (offset + gap*i);

            if(!this.srcSpeedUIs) {
              this.srcSpeedUIs = [];
            }

            this.srcSpeedUIs.push(ui);
          } else {
            ui.position = Q.Position.RIGHT_MIDDLE;
            ui.offsetX = -(offset + gap*i);

            if(!this.dstSpeedUIs) {
              this.dstSpeedUIs = [];
            }

            this.dstSpeedUIs.push(ui);
          }

          this.addUI(ui);
        }
      },
      /**
       * 대여폭 UI 색상 변경
       * @param  {[type]} color [description]
       * @return {[type]}       [description]
       */
      changeSpeedColor: function(color) {
        if(this.srcSpeedUIs) {
          this.srcSpeedUIs.forEach(function(ui){
            ui.fillColor = color;
          })
        }

        if(this.dstSpeedUIs) {
          this.dstSpeedUIs.forEach(function(ui){
            ui.fillColor = color;
          })
        }
      },
      /**
       * 회선 성능 UI 생성
       * @param  {[type]} model [description]
       * @return {[type]}       [description]
       */
      makeRscValue: function(model) {
        var ui = new Q.LabelUI();
        ui.data = '-';
        ui.position = Q.Position.CENTER_MIDDLE;
        ui.border = 1;
        ui.padding = new Q.Insets(0, 5); // top: 0, left: 10, bottom: 0, right: 10
        ui.zIndex = 1; // 맨 위에 보이도록한다
        ui.backgroundColor = '#FFFFFF';
        ui.color = '#000000';
        ui.fontFamily = '나눔고딕';
        ui.fontSize = 10;

        this.rscValueLabelUI = ui;
        this.addUI(ui, [
          {
            property : 'rscValue',
            propertyType : Q.Consts.PROPERTY_TYPE_CLIENT,
            bindingProperty : 'data'
          },
          {
            property : 'borderColor',
            propertyType : Q.Consts.PROPERTY_TYPE_CLIENT,
            bindingProperty : 'borderColor'
          }
      ]);
      },
      /**
       * 회선 이름 표현
       * @param  {[type]} model [description]
       * @return {[type]}       [description]
       */
      makeIfLabel: function (model, direction) {
        var label = this.getIfLabel(model, direction);

        if (label && model.lineOptions && model.lineOptions.showIfLabelCheckbox === '1') {
          if ((direction == 'SRC' && !this.srcLabelUI) || (direction == 'DST' && !this.dstLabelUI)) {
            var ui = new Q.LabelUI();
            ui.fontFamily = '나눔고딕';
            ui.fontSize = 10;
            ui.color = '#000000';
            ui.backgroundColor = 'rgba(255, 255, 255, 0.9)';
            ui.position = direction == 'SRC' ? Q.Position.LEFT_MIDDLE : Q.Position.RIGHT_MIDDLE;
            ui.anchorPosition = direction == 'SRC' ? Q.Position.LEFT_MIDDLE : Q.Position.RIGHT_MIDDLE;
            ui.showPointer = false;
            ui.padding = new Q.Insets(0, 2);

            var arrowType = model.lineOptions && model.lineOptions.hasOwnProperty('arrowType') && model.lineOptions.arrowType;

            if (direction == 'SRC') {
              var offset = 0;
              offset += (this.srcSpeedUIs ? 10 : 0);
              offset += arrowType == 'S' || arrowType == 'B' ? 10 : 0;
              ui.offsetX = offset;
              this.addUI(ui);
              this.srcLabelUI = ui;
            } else {
              var offset = 0;
              offset += (this.dstSpeedUIs ? -10 : 0);
              offset += arrowType == 'D' || arrowType == 'B' ? -10 : 0;
              ui.offsetX = offset;
              this.addUI(ui);
              this.dstLabelUI = ui;
            }
          }

          if (direction == 'SRC') {
            this.srcLabelUI.data = label;
          } else {
            this.dstLabelUI.data = label;
          }
        } else {
          if (direction == 'SRC') {
            if(this.srcLabelUI) {
              this.removeUI(this.srcLabelUI);
              this.srcLabelUI = null;
            }
          } else {
            if(this.dstLabelUI) {
              this.removeUI(this.dstLabelUI);
              this.dstLabelUI = null;
            }
          }
        }
      },
      getIfLabel: function(model, direction) {
        var name = direction === 'SRC' ? 'srcNetinterfaceName' : 'dstNetinterfaceName';
        var desc = direction === 'SRC' ? 'srcNetinterfaceDesc' : 'dstNetinterfaceDesc';
        var alias = direction === 'SRC' ? 'srcNetinterfaceAlias' : 'dstNetinterfaceAlias';

        // 1. 우선순위대로 이름 설정
        var tempLabel = MapUtil.getInterfaceLabel(model[alias], model[name], model[desc], model.lineOptions.showIfLabelCombobox);

        // 2. 없으면 기본 이름으로..
        if (isEmpty(tempLabel)) {
          tempLabel = direction === 'SRC' ? model.srcObjName : model.dstObjName;
        }

        // 기본 이름 재할당
        // this.set((direction === 'SRC' ? 'srcObjName' : 'dstObjName'), tempLabel);

        if (isEmpty(tempLabel)) {
          return null;
        } else {
          var label = tempLabel;
          // 회선 길이에 따라 라벨 글자 길이 제한
          // var ui = MapInfo.getInstance(this).getGraph().getUI(this.id);
          // if (ui) {
          //   var labelLength = (ui.length / 2) / 10;
          //   label = tempLabel.length > labelLength ? tempLabel.substr(0, labelLength) + '..' : tempLabel;
          // }
          return label;
        }
      },
      updateAnimation: function() {
        var model = this.get('model');

        if (MapInfo.getInstance(this) && MapInfo.getInstance(this).getGraph()) {
          MapInfo.getInstance(this).getGraph().flowingSupport.removeFlowing(this);
          if(MapInfo.getInstance(this).getGraph().editable == false) {
            var dot = (model.srcObjId > 0 || model.dstObjId > 0) ? 1 : 0;
            var dash = model.lineOptions && model.lineOptions.hasOwnProperty('dashType') && model.lineOptions.dashType;
            var show = localStorage.getItem('map.filter.animation') != 'HIDE';

            if (show && (dot > 0 || dash != 'default')) {
              MapInfo.getInstance(this).getGraph().flowingSupport.addFlowing(this, dot);
            }
          }
        }
      },
      updateAutomapLanStatus: function(model) {
        if (model.status === 'D') {
          if (!this.automapLanStatusUI) {
            var ui = new Q.ImageUI();
            ui.rotatable = false;
            ui.size = {
              width: 5,
              height: 5,
            }
            ui.data = 'delete_lan.svg';

            this.automapLanStatusUI = ui;
            this.addUI(ui);
          }
        } else {
          if(this.automapLanStatusUI) {
            this.removeUI(this.automapLanStatusUI);
            this.automapLanStatusUI = null;
          }
        }
      },
  };
  Q.extend(LanModel, Q.Edge);

  Object.defineProperties(Q.Edge.prototype, {
  	name: {
  		get: function() {
  		},
  		set: function(name) {
  		}
  	},
  });


  /**
   * 가상객체 Model
   * @param       {[type]} model [description]
   * @constructor
   */
  function VirtualObjectModel(model) {
      Q.doSuperConstructor(this, VirtualObjectModel);

      this.initialize(model);
  }
  VirtualObjectModel.prototype = {
      update: function() {
          var model = this.get('model');

          if(model.elementId) {
            this.id = model.elementId;
          }
          this.name = model.label;
          this.image = getImage(this);
          this.size = getSize(this.size, model);
          this.x = model.x;
          this.y = model.y;
          this.rotate = model.r * Math.PI / 180;
          this.zIndex = model.z;

          this.initVirtualEffect();

          applyStyle(this, model);
      },
      initVirtualEffect: function() {
        var model = this.get('model');

        if(model.virtualEffectShowFlag == '1') {
          this.eventStatus = {
            eventlevelColorBg: model.virtualEffectColor,
          };
        } else {
          this.eventStatus = null;
        }
      },
      defaultProperty: function() {
        return {
          elementId: null,
          objtypeId: 'ETC',
          customimageId: -1,
          virtualEffectShowFlag: '1',
          virtualEffectColor: '#99d47c',
          label: '',
          labelPosition: 'CB',
          labelOptions: {
            labelSize: 11,
            labelBold: false,
          },
          labelColor: '#000000',
          showLabelFlag: '1',
          labelBoxColor: '#ffffff',
          showLabelBoxFlag: '0',
          labelFont: '나눔고딕',
          x: 0,
          y: 0,
          z: 0,
          r: 0,
          width: 46,
          height: 46,
          alpha: 1,
          styleOptions: {
            imageType: 'flat',
          },
        };
      },
  };
  Q.extend(VirtualObjectModel, Q.Node);

  /**
   * 사용자정의1 Model
   * @param       {[type]} model [description]
   * @constructor
   */
  function Custom1Model(model) {
      Q.doSuperConstructor(this, Custom1Model);

      this.initialize(model);
  }
  Custom1Model.prototype = {
      update: function() {
          var model = this.get('model');

          if(model.elementId) {
            this.id = model.elementId;
          }
          this.name = model.label;
          this.image = getImage(this, getImageName(model.styleOptions.imageType, 'UK'));
          this.size = getSize(this.size, model);
          this.x = model.x;
          this.y = model.y;
          this.rotate = model.r * Math.PI / 180;
          this.zIndex = model.z;
          this.objIds = model.objIds;

          applyStyle(this, model);
      },
      updateEvent: function(eventStatus) {
        this.eventStatus = eventStatus;

        this.update();
      },
      defaultProperty: function() {
        return {
          elementId: null,
          customimageId: -1,
          label: '',
          labelPosition: 'CB',
          labelOptions: {
            labelSize: 11,
            labelBold: false,
          },
          labelColor: '#000000',
          showLabelFlag: '1',
          labelBoxColor: '#ffffff',
          showLabelBoxFlag: '0',
          labelFont: '나눔고딕',
          x: 0,
          y: 0,
          z: 0,
          r: 0,
          width: 46,
          height: 46,
          alpha: 1,
          styleOptions: {
            imageType: 'flat',
          },
          objIds:[]
        };
      },
  };
  Q.extend(Custom1Model, Q.Node);


  /**
   * 가상랜 Model
   * @param       {[type]} model    [description]
   * @param       {[type]} srcNode [description]
   * @param       {[type]} dstNode [description]
   * @constructor
   */
  function VirtualLanModel(model) {
      Q.doSuperConstructor(this, VirtualLanModel);

      this.moveTo(-(model.length/2), 0);
      this.lineTo((model.length/2), 0);

      this.initialize(model);
  }
  VirtualLanModel.prototype = {
      update: function() {
        var model = this.get('model');

        this.x = model.x;
        this.y = model.y;
        this.rotate = model.r * Math.PI / 180;
        this.zIndex = model.z;

        applyStyle(this, model);
      },
      defaultProperty: function() {
        return {
          elementId: null,
          length: 64,
          weight: 1,
          color: '#000000',
          direction: '',
          x: 0,
          y: 0,
          z: 0,
          strokeOptions: {
            weight: 1,
            color: '#000000',
            alpha: 1,
          },
          lineOptions: {
            dashType: 'default',
            pathSegments: [
              // 값 형태
              /* {
              //   "type:": "l",
  		        //   "points": [200, -180]
              } */
            ]
          }
        };
      },
  };
  Q.extend(VirtualLanModel, Q.Bus);


  /**
   * 하위상황판 Model
   * @param       {[type]} model [description]
   * @constructor
   */
  function SubTopologymapModel(model) {
      Q.doSuperConstructor(this, SubTopologymapModel);

      this.initialize(model);
  }
  SubTopologymapModel.prototype = {
      update: function() {
          var model = this.get('model');

          if(model.elementId) {
            this.id = model.elementId;
          }
          this.name = this.getName(model);
          this.image = getImage(this, getImageName(model.styleOptions.imageType, 'GROUP'));
          this.size = getSize(this.size, model);
          this.x = model.x;
          this.y = model.y;
          this.rotate = model.r * Math.PI / 180;
          this.zIndex = model.z;

          applyStyle(this, model);
      },
      updateEvent: function(eventStatus) {
        this.eventStatus = eventStatus;

        this.updateAnimation();
        this.update();
      },
      getName: function(model) {
        var label = model.label;

        label = label.replace(/%node%/gi, model.mapName);
        label = label.replace(/%n%/gi, '\n');

        return label;
      },
      updateAnimation: function() {
        var model = this.get('model');

        if (MapInfo.getInstance(this).getGraph()) {
          MapInfo.getInstance(this).getGraph().eventEffectSupport.hide(this);
          if(MapInfo.getInstance(this).getGraph().editable == false && checkShowEvent(this, model) && localStorage.getItem('map.filter.animation') != 'HIDE') {
            MapInfo.getInstance(this).getGraph().eventEffectSupport.show(this);
          }
        }
      },
      defaultProperty: function() {
        return {
          elementId: null,
          mapId: -1,
          mapName: '',
          label: '%node%',
          labelPosition: 'CB',
          labelOptions: {
            labelSize: 11,
            labelBold: false,
          },
          labelColor: '#000000',
          showLabelFlag: '1',
          labelBoxColor: '#ffffff',
          showLabelBoxFlag: '0',
          labelFont: '나눔고딕',
          x: 0,
          y: 0,
          z: 0,
          r: 0,
          width: 46,
          height: 46,
          alpha: 1,
          linkMode: '0',
          customimageId: -1,
          styleOptions: {
            showNormalColor: true,
            imageType: 'flat',
          }
        };
      },
  };
  Q.extend(SubTopologymapModel, Q.Node);


  /**
   * 도형 Model
   * @param       {[type]} model      [description]
   * @constructor
   */
  function ShapeModel(model){
      Q.doSuperConstructor(this, ShapeModel);

      this.initialize(model);
  }
  ShapeModel.prototype = {
      update: function(){
          var model = this.get('model');

          if(model.elementId) {
            this.id = model.elementId;
          }
          this.path = Q.Shapes.getAllShapes(-(model.width/2), -(model.height/2), model.width, model.height)[model.shapeType];
          this.size = getSize(this.size, model);
          this.x = model.x;
          this.y = model.y;
          this.rotate = model.r * Math.PI / 180;
          this.zIndex = model.z;

          applyStyle(this, model);
      },
      defaultProperty: function() {
        return {
          elementId: null,
          shapeType: 'oval',
          x: 0,
          y: 0,
          z: 0,
          r: 0,
          width: 46,
          height: 46,
          fillType: 'Solid Fill',
          fillOptions: {
            color: '#ffffff',
            alpha: 1,
          },
          strokeType: '',
          strokeOptions: {
            color: '#000000',
            weight: 1,
            alpha: 1,
          },
        };
      },
  };
  Q.extend(ShapeModel, Q.ShapeNode);


  /**
   * 이미지 Model
   * @param       {[type]} model      [description]
   * @param       {[type]} shapeType [description]
   * @constructor
   */
  function ImageModel(model){
      Q.doSuperConstructor(this, ImageModel);

      this.initialize(model);
  }
  ImageModel.prototype = {
      update: function(){
          var model = this.get('model');

          if(model.elementId) {
            this.id = model.elementId;
          }
          this.size = getSize(this.size, model);
          this.image = getImage(this);
          this.x = model.x;
          this.y = model.y;
          this.rotate = model.r * Math.PI / 180;
          this.zIndex = model.z;
      },
      defaultProperty: function() {
        return {
          elementId: null,
          customimageId: -1,
          x: 0,
          y: 0,
          z: 0,
          r: 0,
          // width: 64,
          // height: 64,
          alpha: 1,
        };
      },
  };
  Q.extend(ImageModel, Q.Node);

  /**
   * 텍스트 Model
   * @param       {[type]} model [description]
   * @constructor
   */
  function LabelModel(model){
      Q.doSuperConstructor(this, LabelModel);

      this.initialize(model);
      this.dblclickable = true;
  }
  LabelModel.prototype = {
      update: function(){
          var model = this.get('model');

          if(model.elementId) {
            this.id = model.elementId;
          }

          this.name = model.text;
          this.size = getSize(this.size, model);
          this.x = model.x;
          this.y = model.y;
          this.rotate = model.r * Math.PI / 180;
          this.zIndex = model.z;

          applyStyle(this, model);
      },
      defaultProperty: function() {
        return {
          elementId: null,
          text: 'Test',
          label: '',
          labelPosition: 'CM',
          labelOptions: {
            labelSize: 11,
            labelBold: false,
          },
          labelColor: '#000000',
          labelFont: '나눔고딕',
          x: 0,
          y: 0,
          z: 0,
          r: 0,
          width: 64,
          height: 64,
          alpha: 1,
        };
      },
  };
  Q.extend(LabelModel, Q.Text);

  Q.Graph.prototype.createEdge = function(t, e, i) {
  	if (t instanceof Q.Node) {
  		var n = i;
  		i = e, e = t, t = n
  	}
  	var s = new LanModel({}, e, i);

    MapInfo.getInstance(t).addEditHistory({
      type: MapConst.HISTORY_TYPE.ADD,
      elements: [s]
    });

  	return t && (s.$name = t), this.graphModel.add(s), s
  }

  // 선택 된 오브젝트 삭제 기능 Override
  Q.Graph.prototype.removeSelectionAutomap = function() {
    var t = this.selectionModel._j7;
    t = filter(t, (target) => {
      var removable = true;

      if (target instanceof Q.ManagedObjectModel) {  // 연결장비는 삭제하지 못한다.
        removable = !(target.get('isAutomapDevice') === true);
      } else if (target instanceof Q.LanModel) { // 연결장비간에 연결 된 회선은 삭제하지 못한다.
        removable = !(target.get('isSrcAutomapTarget') === true || target.get('isDstAutomapTarget') === true);
      }

      return removable;
    });
    return t && 0 != t.length ? (t = t.slice(), this._jzModel.remove(t), t) : !1
  }

  function applyStyle(target, model) {
    if(model.labelColor) {
      target.setStyle(Q.Styles.LABEL_COLOR, model.labelColor);
    }

    if(model.labelFont) {
      target.setStyle(Q.Styles.LABEL_FONT_FAMILY, model.labelFont);
    }

    if(model.labelOptions && model.labelOptions.hasOwnProperty('labelSize')) {
      target.setStyle(Q.Styles.LABEL_FONT_SIZE, model.labelOptions.labelSize);
    }

    if(model.showLabelBoxFlag) {
      var color = (parseInt(model.showLabelBoxFlag) && model.labelBoxColor != void 0) ? MapUtil.hexToRgbA(model.labelBoxColor, 0.9) : null;

      target.setStyle(Q.Styles.LABEL_PADDING, 3);
      target.setStyle(Q.Styles.LABEL_BACKGROUND_COLOR, color);
    }

    if(model.showLabelFlag) {
      var visible = localStorage.getItem('map.filter.label') == 'SHOW' || (parseInt(model.showLabelFlag) == 1 && localStorage.getItem('map.filter.label') == 'DEFAULT');
      target.setStyle(Q.Styles.LABEL_VISIBLE, visible);
    }

    if(model.labelOptions && model.labelOptions.hasOwnProperty('labelBold')) {
      target.setStyle(Q.Styles.LABEL_FONT_STYLE, model.labelOptions.labelBold ? 'bold' : 'normal');
    }

    if(model.labelPosition) {
      if(target instanceof LabelModel){
        target.setStyle(Q.Styles.LABEL_ALIGN_POSITION, getLabelPosition(model.labelPosition)[0]);
      }
      target.setStyle(Q.Styles.LABEL_POSITION, getLabelPosition(model.labelPosition)[0]);
      target.setStyle(Q.Styles.LABEL_ANCHOR_POSITION, getLabelPosition(model.labelPosition)[1]);
    }

    if(model.strokeOptions && model.strokeOptions.hasOwnProperty('color')) {
      target.setStyle(Q.Styles.EDGE_COLOR, model.strokeOptions.color);
      target.setStyle(Q.Styles.SHAPE_STROKE_STYLE, MapUtil.hexToRgbA(model.strokeOptions.color, model.strokeOptions.alpha != void 0 ? model.strokeOptions.alpha : 1));
    }

    if(model.strokeOptions && model.strokeOptions.hasOwnProperty('alpha')) {
      target.setStyle(Q.Styles.EDGE_COLOR, MapUtil.hexToRgbA(model.strokeOptions.color || '#000000', model.strokeOptions.alpha));
      target.setStyle(Q.Styles.SHAPE_STROKE_STYLE, MapUtil.hexToRgbA(model.strokeOptions.color || '#000000', model.strokeOptions.alpha));
    }

    if(model.strokeOptions && model.strokeOptions.hasOwnProperty('weight')) {
      target.setStyle(Q.Styles.EDGE_WIDTH, model.strokeOptions.weight || 1);

      target.setStyle(Q.Styles.SHAPE_STROKE, model.strokeOptions.weight || 1);
    }

    if(model.fillOptions && model.fillOptions.hasOwnProperty('color')) {
      target.setStyle(Q.Styles.SHAPE_FILL_COLOR, MapUtil.hexToRgbA(model.fillOptions.color, model.fillOptions.alpha));
    }

    if(model.fillOptions && model.fillOptions.hasOwnProperty('alpha')) {
      target.setStyle(Q.Styles.SHAPE_FILL_COLOR, MapUtil.hexToRgbA(model.fillOptions.color || '#ffffff', model.fillOptions.alpha));
    }

    if(model.alpha != void 0) {
      if(target instanceof ManagedObjectModel) {
        if(model.deadObj) {
            target.setStyle(Q.Styles.ALPHA, 0.7);
        } else {
            target.setStyle(Q.Styles.ALPHA, model.alpha);
        }
      } else {
        target.setStyle(Q.Styles.ALPHA, model.alpha);
      }
    }

    if(model.lineDirection) {
      if(model.lineDirection === 'SEGMENT_CURVE_TO'){
        target.updateLanCurve();
      } else {
        target.edgeType = Q.Consts[model.lineDirection] || Q.Consts.EDGE_TYPE_DEFAULT;
      }
    }

    if(model.lineOptions && model.lineOptions.hasOwnProperty('dashType')) {
      switch (model.lineOptions.dashType) {
        case 'default':
        case false:
          target.setStyle(Q.Styles.EDGE_LINE_DASH, null);
          target.setStyle(Q.Styles.SHAPE_LINE_DASH, null);
          break;
        case 'dash1':
        case true:
          target.setStyle(Q.Styles.EDGE_LINE_DASH, [8, 8]);
          target.setStyle(Q.Styles.SHAPE_LINE_DASH, [8, 8]);
          break;
        default:
      }
    }

    // 선 화살표
    if(target instanceof Q.Edge && model.lineOptions && model.lineOptions.hasOwnProperty('arrowType')) {
      switch (model.lineOptions.arrowType) {
        case 'N':
          target.setStyle(Q.Styles.ARROW_FROM, false);
          target.setStyle(Q.Styles.ARROW_TO, false);
          break;
        case 'S':
          target.setStyle(Q.Styles.ARROW_FROM, true);
          target.setStyle(Q.Styles.ARROW_TO, false);
          break;
        case 'D':
          target.setStyle(Q.Styles.ARROW_FROM, false);
          target.setStyle(Q.Styles.ARROW_TO, true);
          break;
        case 'B':
          target.setStyle(Q.Styles.ARROW_FROM, true);
          target.setStyle(Q.Styles.ARROW_TO, true);
          break;
      }
    }

    // 이벤트 색상
    if (checkShowEvent(target, model)) {
      var eventColor = target.eventStatus.eventlevelColorBg;
      if (target instanceof Q.Node) {
        target.setStyle(Q.Styles.RENDER_COLOR, eventColor);

      } else if (target instanceof Q.Edge) {
        target.setStyle(Q.Styles.EDGE_COLOR, eventColor);
        target.changeSpeedColor && target.changeSpeedColor(eventColor);
        target.updateAnimation && target.updateAnimation();
        target.set('borderColor', eventColor);
      }
    } else {
      var normalColor = store.state.common.eventlevelInfo['NM'].eventlevelColorBg;
      if (target instanceof Q.Node) {
        if(model.styleOptions && model.styleOptions.showNormalColor) {
          target.setStyle(Q.Styles.RENDER_COLOR, normalColor);
        } else {
          target.setStyle(Q.Styles.RENDER_COLOR, null);
        }
      } else if (target instanceof Q.Edge) {
        if(model.styleOptions && model.styleOptions.showNormalColor) {
          target.setStyle(Q.Styles.EDGE_COLOR, normalColor);
          target.changeSpeedColor && target.changeSpeedColor(normalColor);
          target.updateAnimation && target.updateAnimation();
          target.set('borderColor', normalColor);
        } else {
          var modelColor = model.strokeOptions.color;
          target.setStyle(Q.Styles.EDGE_COLOR, modelColor);
          target.changeSpeedColor && target.changeSpeedColor(modelColor);
          target.updateAnimation && target.updateAnimation();
          target.set('borderColor', modelColor);
        }
      }
    }

    // 비 관리대상은 이벤트 색상 미표현 처리
    if (MapInfo.getInstance(this).getGraph()) {
      // 모니터링 모드이고, 관리대상이고, 관리여부가 해제 상태일 경우
      if(MapInfo.getInstance(this).getGraph().editable == false && target instanceof Q.ManagedObjectModel && model.objManagementApplyFlag == '0') {
        target.setStyle(Q.Styles.RENDER_COLOR, null);
      }
    }
  };
  function checkShowEvent(target, model) {
    if (target.eventStatus && localStorage.getItem('map.filter.event') != 'HIDE') {
      if (target instanceof ManagedObjectModel && model.objManagementApplyFlag == '0') {
        return false;
      } else if (target instanceof VirtualObjectModel && model.virtualEffectShowFlag == '0') {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  };
  function getName(model) {
    var label = model.label;

    label = label.replace(/%node%/gi, model.objName || model.ipaddress || '');
    label = label.replace(/%n%/gi, '\n');
    label = label.replace(/%ip%/gi, model.ipaddress);

    return label;
  };
  function getSize(orgSize, model) {
    var newSize = {width: model.width, height: model.height};
    return JSON.stringify(orgSize) === JSON.stringify(newSize) ? orgSize : newSize;
  };
  function getLabelPosition(labelPosition) {
    switch (labelPosition) {
      case 'CT':
        return [Q.Position.CENTER_TOP, Q.Position.CENTER_BOTTOM];
        break;
      case 'CB':
        return [Q.Position.CENTER_BOTTOM, Q.Position.CENTER_TOP];
        break;
      case 'CM':
        return [Q.Position.CENTER_MIDDLE, Q.Position.CENTER_MIDDLE];
        break;
      case 'RT':
        return [Q.Position.RIGHT_TOP, Q.Position.LEFT_BOTTOM];
        break;
      case 'RM':
        return [Q.Position.RIGHT_MIDDLE, Q.Position.LEFT_MIDDLE];
        break;
      case 'RB':
        return [Q.Position.RIGHT_BOTTOM, Q.Position.LEFT_TOP];
        break;
      case 'LT':
        return [Q.Position.LEFT_TOP, Q.Position.RIGHT_BOTTOM];
        break;
      case 'LM':
        return [Q.Position.LEFT_MIDDLE, Q.Position.RIGHT_MIDDLE];
        break;
      case 'LB':
        return [Q.Position.LEFT_BOTTOM, Q.Position.RIGHT_TOP];
        break;
      default:
        return [Q.Position.CENTER_BOTTOM, Q.Position.CENTER_TOP];
    }
  };
  function getImageName(imageType, imageName) {
    if(imageType == '3d') {
      if(!MapUtil.hasPngImage(imageName)) {
        imageName = 'ETC';
      }
      return `${baseUrl}/image/topologymap/object/3d/${imageName}.png`;
    } else {
      imageName = imageName + '.svg';

      if(!Q.hasImage(imageName)) {
        return 'ETC.svg';
      }

      return imageName;
    }
  };
  function getImage(target, defaultImage) {
    var model = target.get('model');
    if (model.customimageId && model.customimageId > 0) {
      return store.state.common.customimage.hasOwnProperty(model.customimageId) ? (MapConst.IMAGE_PATH + encodeURIComponent(store.state.common.customimage[model.customimageId].customimageSrc)) : model.objtypeId + '.svg';
    } else {
      if (model.objtypeId == 'NETINTERFACE') {
        var name = 'IF' + ('_' + (model.netinterfaceType == '-' ? 'OTHER' : model.netinterfaceType)) + (model.netinterfaceStatusAdmin == '1' ? '' : '_X') + '_16X';
        var imageName = '';

        switch (name) {
          case 'IF_6_16X':
            imageName = "IF";
            break;
          case 'IF_6_X_16X':
            imageName = "IF_X";
            break;
          case 'IF_24_16X':
            imageName = "IF_LOOPBACK";
            break;
          case 'IF_24_X_16X':
            imageName = "IF_LOOPBACK_X";
            break;
          case 'IF_OTHER_16X':
            imageName = "IF_OTHER";
            break;
          case 'IF_OTHER_X_16X':
            imageName = "IF_OTHER_X";
            break;
          case 'IF_16X':
            imageName = "IF";
            break;
          case 'IF_X_16X':
            imageName = "IF_X";
            break;
          default:
            if(name.indexOf('_X') > -1) {
              imageName = "IF_OTHER_X";
            } else {
              imageName = "IF_OTHER";
            }
            break;
        }

        return getImageName(model.styleOptions.imageType, imageName);
      } else {
        if(defaultImage) {
            return defaultImage;
        } else {
            return getImageName(model.styleOptions.imageType, model.objtypeId);
        }
      }
    }
  };
  Q.checkShowEvent = checkShowEvent;
  Q.getImage = getImage;
  Q.BaseModel = BaseModel;
  Q.ManagedObjectModel = ManagedObjectModel;
  Q.LanModel = LanModel;
  Q.ImageModel = ImageModel;
  Q.VirtualObjectModel = VirtualObjectModel;
  Q.Custom1Model = Custom1Model;
  Q.VirtualLanModel = VirtualLanModel;
  Q.SubTopologymapModel = SubTopologymapModel;
  Q.ShapeModel = ShapeModel;
  Q.LabelModel = LabelModel;
})(window.Q);
// jshint ignore:end
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/views/topologymap/js/models.js